export default __webpack_public_path__ + "static/media/Jubilat-Regular.e19f4b10.otf";